import React, { type ComponentType, type FunctionComponent } from 'react';

import type {
  ContextMenuContainerProps,
  GetDefinition,
} from '../components/context_menu/types';
import type { ObjectWithId } from '../types/common';

export const CONTEXT_MENU_ACLS_LIST = 'ACLS_LIST';
export const CONTEXT_MENU_ADMIN_ACL_TEMPLATES = 'ADMIN_ACL_TEMPLATES';
export const CONTEXT_MENU_ADMIN_APPLICATIONS = 'ADMIN_APPLICATIONS';
export const CONTEXT_MENU_ADMIN_CUSTOM_ACTIONS = 'ADMIN_CUSTOM_ACTIONS';
export const CONTEXT_MENU_ADMIN_EXPORT_LOCATIONS = 'ADMIN_EXPORT_LOCATIONS';
export const CONTEXT_MENU_ADMIN_GROUPS = 'ADMIN_GROUPS';
export const CONTEXT_MENU_ADMIN_GROUP_USERS = 'ADMIN_GROUP_USERS';
export const CONTEXT_MENU_ADMIN_TEAM_USERS = 'ADMIN_TEAM_USERS';
export const CONTEXT_MENU_ADMIN_ROLE_GROUP_USERS = 'ADMIN_ROLE_GROUP_USERS';
export const CONTEXT_MENU_ADMIN_JOBS = 'ADMIN_JOBS';
export const CONTEXT_MENU_ADMIN_JOBS_WIDGETS = 'ADMIN_JOBS_WIDGETS';
export const CONTEXT_MENU_ADMIN_METADATA_CATEGORIES =
  'CONTEXT_MENU_ADMIN_METADATA_CATEGORIES';
export const CONTEXT_MENU_ADMIN_METADATA_FIELDS = 'ADMIN_METADATA_FIELDS';
export const CONTEXT_MENU_ADMIN_RECYCLE_BIN = 'ADMIN_RECYCLE_BIN';
export const CONTEXT_MENU_ADMIN_ROLE_GROUPS = 'ADMIN_ROLE_GROUPS';
export const CONTEXT_MENU_ADMIN_STORAGES = 'ADMIN_STORAGES';
export const CONTEXT_MENU_ADMIN_STORAGE_BROWSER = 'ADMIN_STORAGE_BROWSER';
export const CONTEXT_MENU_ADMIN_SYSTEM_DOMAINS = 'ADMIN_SYSTEM_DOMAINS';
export const CONTEXT_MENU_ADMIN_TEAMS = 'ADMIN_TEAMS';
export const CONTEXT_MENU_ADMIN_TRANSCODERS = 'ADMIN_TRANSCODERS';
export const CONTEXT_MENU_ADMIN_USERS = 'ADMIN_USERS';
export const CONTEXT_MENU_ADMIN_WEBHOOKS = 'ADMIN_WEBHOOKS';
export const CONTEXT_MENU_ADMIN_SHARES = 'ADMIN_SHARES';
export const CONTEXT_MENU_ASSET_SHARE_DOWNLOAD = 'ASSET_SHARE_DOWNLOAD';
export const CONTEXT_MENU_COLLECTION_SHARE_DOWNLOAD =
  'COLLECTION_SHARE_DOWNLOAD';
export const CONTEXT_MENU_ASSET_VERSION_ITEM = 'ASSET_VERSION_ITEM';
export const CONTEXT_MENU_GEARBOX_ASSET = 'GEARBOX_ASSET';
export const CONTEXT_MENU_GEARBOX_ASSET_COMMENTS = 'GEARBOX_ASSET_COMMENTS';
export const CONTEXT_MENU_GEARBOX_ASSET_TRANSCRIPTIONS =
  'GEARBOX_ASSET_TRANSCRIPTIONS';
export const CONTEXT_MENU_GEARBOX_COLLECTION = 'GEARBOX_COLLECTION';
export const CONTEXT_MENU_GEARBOX_SHARE_COLLECTION = 'GEARBOX_SHARE_COLLECTION';
export const CONTEXT_MENU_GEARBOX_JOBS_DASHBOARD = 'GEARBOX_JOBS_DASHBOARD';
export const CONTEXT_MENU_GEARBOX_SEARCH = 'GEARBOX_SEARCH';
export const CONTEXT_MENU_PANELS_ENTITY_POSTERS = 'PANELS_ENTITY_POSTERS';
export const CONTEXT_MENU_PANELS_FILES_FORMATS = 'PANELS_FILES_FORMATS';
export const CONTEXT_MENU_PANELS_FILES_PROXY = 'PANELS_FILES_PROXY';
export const CONTEXT_MENU_PANELS_FILES_TYPE = 'PANELS_FILES_TYPE';
export const CONTEXT_MENU_PANELS_POSTER_TYPE = 'PANELS_POSTER_TYPE';
export const CONTEXT_MENU_PANELS_SAVED_SEARCHES = 'PANELS_SAVED_SEARCHES';
export const CONTEXT_MENU_SEARCH_ITEMS = 'SEARCH_ITEMS';
export const CONTEXT_MENU_SEARCH_ITEMS_REORDER = 'SEARCH_ITEMS_REORDER';
export const CONTEXT_MENU_UPLOADER_ITEMS = 'UPLOADER_ITEMS';
export const CONTEXT_MENU_UPLOADER = 'UPLOADER';
export const CONTEXT_MENU_IDENTITY_PROVIDER = 'IDENTITY_PROVIDER';
export const CONTEXT_MENU_EDIT_SEARCH_SETTINGS = 'EDIT_SEARCH_SETTINGS';
export const CONTEXT_MENU_SYSTEM_LOG_STREAMING =
  'CONTEXT_MENU_SYSTEM_LOG_STREAMING';
export const CONTEXT_PANELS_FACE_RECOGNITION =
  'CONTEXT_PANELS_FACE_RECOGNITION';
export const CONTEXT_MENU_ADMIN_AUTOMATIONS = 'CONTEXT_MENU_ADMIN_AUTOMATIONS';
export const CONTEXT_MENU_ADMIN_AUTOMATIONS_JOBS =
  'CONTEXT_MENU_ADMIN_AUTOMATIONS_JOBS';
export const CONTEXT_MENU_ADMIN_AUTOMATIONS_ACLS_ACTION =
  'CONTEXT_MENU_ADMIN_AUTOMATIONS_ACLS_ACTION';
export const CONTEXT_MENU_COLLECTION_TREE = 'CONTEXT_MENU_COLLECTION_TREE';

type ContextMenuId =
  | typeof CONTEXT_MENU_ACLS_LIST
  | typeof CONTEXT_MENU_ADMIN_ACL_TEMPLATES
  | typeof CONTEXT_MENU_ADMIN_APPLICATIONS
  | typeof CONTEXT_MENU_ADMIN_CUSTOM_ACTIONS
  | typeof CONTEXT_MENU_ADMIN_EXPORT_LOCATIONS
  | typeof CONTEXT_MENU_ADMIN_GROUPS
  | typeof CONTEXT_MENU_ADMIN_GROUP_USERS
  | typeof CONTEXT_MENU_ADMIN_TEAM_USERS
  | typeof CONTEXT_MENU_ADMIN_ROLE_GROUP_USERS
  | typeof CONTEXT_MENU_ADMIN_JOBS
  | typeof CONTEXT_MENU_ADMIN_JOBS_WIDGETS
  | typeof CONTEXT_MENU_ADMIN_METADATA_CATEGORIES
  | typeof CONTEXT_MENU_ADMIN_METADATA_FIELDS
  | typeof CONTEXT_MENU_ADMIN_RECYCLE_BIN
  | typeof CONTEXT_MENU_ADMIN_ROLE_GROUPS
  | typeof CONTEXT_MENU_ADMIN_STORAGES
  | typeof CONTEXT_MENU_ADMIN_STORAGE_BROWSER
  | typeof CONTEXT_MENU_ADMIN_SYSTEM_DOMAINS
  | typeof CONTEXT_MENU_ADMIN_TEAMS
  | typeof CONTEXT_MENU_ADMIN_TRANSCODERS
  | typeof CONTEXT_MENU_ADMIN_USERS
  | typeof CONTEXT_MENU_ADMIN_WEBHOOKS
  | typeof CONTEXT_MENU_ADMIN_SHARES
  | typeof CONTEXT_MENU_ASSET_SHARE_DOWNLOAD
  | typeof CONTEXT_MENU_COLLECTION_SHARE_DOWNLOAD
  | typeof CONTEXT_MENU_ASSET_VERSION_ITEM
  | typeof CONTEXT_MENU_GEARBOX_ASSET
  | typeof CONTEXT_MENU_GEARBOX_ASSET_COMMENTS
  | typeof CONTEXT_MENU_GEARBOX_ASSET_TRANSCRIPTIONS
  | typeof CONTEXT_MENU_GEARBOX_COLLECTION
  | typeof CONTEXT_MENU_GEARBOX_SHARE_COLLECTION
  | typeof CONTEXT_MENU_GEARBOX_JOBS_DASHBOARD
  | typeof CONTEXT_MENU_GEARBOX_SEARCH
  | typeof CONTEXT_MENU_PANELS_ENTITY_POSTERS
  | typeof CONTEXT_PANELS_FACE_RECOGNITION
  | typeof CONTEXT_MENU_PANELS_FILES_FORMATS
  | typeof CONTEXT_MENU_PANELS_FILES_PROXY
  | typeof CONTEXT_MENU_PANELS_FILES_TYPE
  | typeof CONTEXT_MENU_PANELS_POSTER_TYPE
  | typeof CONTEXT_MENU_PANELS_SAVED_SEARCHES
  | typeof CONTEXT_MENU_SEARCH_ITEMS
  | typeof CONTEXT_MENU_SEARCH_ITEMS_REORDER
  | typeof CONTEXT_MENU_UPLOADER_ITEMS
  | typeof CONTEXT_MENU_UPLOADER
  | typeof CONTEXT_MENU_IDENTITY_PROVIDER
  | typeof CONTEXT_MENU_EDIT_SEARCH_SETTINGS
  | typeof CONTEXT_MENU_SYSTEM_LOG_STREAMING
  | typeof CONTEXT_MENU_ADMIN_AUTOMATIONS
  | typeof CONTEXT_MENU_ADMIN_AUTOMATIONS_JOBS
  | typeof CONTEXT_MENU_ADMIN_AUTOMATIONS_ACLS_ACTION
  | typeof CONTEXT_MENU_COLLECTION_TREE;

type RegisteredGetDefinition = {
  getDefinition(...args: Parameters<GetDefinition>): ReturnType<GetDefinition>;
}['getDefinition'];

export type ContextMenuContext = {
  [menuId in ContextMenuId]?: RegisteredGetDefinition;
};

const defaultValue = {};

const { Provider, Consumer } =
  React.createContext<ContextMenuContext>(defaultValue);
export const ContextMenuProvider = Provider;
export const ContextMenuConsumer = Consumer;

export const connectContextMenuConsumer =
  <
    Props extends ContextMenuContainerProps<Item, State, Options>,
    Item extends ObjectWithId,
    State,
    Options,
  >(
    Component: ComponentType<ContextMenuContainerProps<Item, State, Options>>,
    menuId: ContextMenuId,
  ): FunctionComponent<Props> =>
  (props) => (
    <ContextMenuConsumer>
      {(context: ContextMenuContext) => (
        <Component {...props} getDefinition={context[menuId]} />
      )}
    </ContextMenuConsumer>
  );
